// QQCARD i18n — Five-language UI strings
// Languages: 繁體中文(zh-TW) / 简体中文(zh-CN) / English / 日本語 / 한국어

export const LANGUAGES = [
  { code: 'zh-TW', label: '繁體中文', flag: '🇹🇼' },
  { code: 'zh-CN', label: '简体中文', flag: '🇨🇳' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'ko', label: '한국어', flag: '🇰🇷' },
];

export const T = {
  'zh-TW': {
    brand: 'QQCARD',
    tagline: '遊戲點數 · 平台儲值 · 訂閱服務',
    nav: {
      home: '首頁',
      games: '遊戲商城',
      platforms: '平台點數',
      console: '主機點卡',
      subs: '訂閱服務',
      vip: 'VIP 黑卡',
      blog: '部落格',
      help: '幫助中心',
      cart: '購物車',
      account: '會員中心',
      signin: '登入',
      signup: '註冊',
      signout: '登出',
      search: '搜尋遊戲、點數、禮物卡...',
    },
    hero: {
      eyebrow: '全球頂級遊戲點數平台',
      explore: '探索商城',
      vip: '加入 VIP',
      live: '線上玩家',
      todayOrders: '今日訂單',
    },
    cta: {
      buyNow: '立即購買',
      addCart: '加入購物車',
      checkout: '前往結帳',
      viewAll: '查看全部',
      seeMore: '看更多',
      backHome: '回到首頁',
      continueShopping: '繼續購物',
      payNow: '立即付款',
      apply: '套用',
      remove: '移除',
      close: '關閉',
      confirm: '確認',
      cancel: '取消',
    },
    sections: {
      categoriesEyebrow: '分類瀏覽',
      categoriesTitle: '一站購足你的數位生活',
      categoriesLead: '從手遊、PC、主機到串流訂閱，所有點卡集中管理',
      flashEyebrow: '限時閃購',
      flashTitle: 'Flash Deals · 限時優惠',
      flashLead: '每日 00:00 / 12:00 / 20:00 更新',
      hotEyebrow: '熱銷排行',
      hotTitle: '熱賣商品',
      hotLead: 'QQCARD 平台精選熱銷',
      newEyebrow: '新品上架',
      newTitle: '本月新上架',
      newLead: '搶先入手最新潮流',
      featuresEyebrow: '為什麼選 QQCARD',
      featuresTitle: '六大優勢，重新定義遊戲儲值',
      vipEyebrow: '榮耀會員',
      vipTitle: 'VIP 黑卡計畫',
      vipLead: '消費越多，回饋越好',
      testimonialEyebrow: '真實玩家見證',
      testimonialTitle: '50 萬+ 玩家共同選擇',
      blogEyebrow: '玩家攻略',
      blogTitle: '最新文章 & 教學',
      faqEyebrow: '常見問題',
      faqTitle: '想問什麼，這裡都有答案',
    },
    product: {
      points: '點數',
      rating: '評分',
      reviews: '則評論',
      delivery: '到帳時間',
      instant: '10 秒到帳',
      official: '官方授權',
      stock: '現貨',
      addedToCart: '已加入購物車',
      pickAmount: '選擇面額',
      qty: '數量',
      total: '小計',
      tutorial: '儲值教學',
      reviewsTab: '玩家評論',
      relatedTitle: '你可能也喜歡',
    },
    cart: {
      title: '購物車',
      empty: '購物車是空的',
      emptyHint: '逛逛熱銷排行，挑選你心愛的點數卡',
      subtotal: '小計',
      discount: '折扣',
      vipRebate: 'VIP 回饋',
      coupon: '優惠碼',
      couponPlaceholder: '輸入優惠碼',
      total: '應付總額',
      itemCount: '項商品',
      removeAll: '清空',
    },
    checkout: {
      title: '安全結帳',
      step1: '訂單明細',
      step2: '付款方式',
      step3: '完成訂單',
      contact: '聯絡資訊',
      email: '電子郵件',
      phone: '手機號碼',
      payment: '選擇付款方式',
      summary: '訂單摘要',
      pay: '確認支付',
      processing: '安全加密處理中...',
      success: '🎉 訂購成功！',
      successHint: '序號已寄至您的信箱，並可在會員中心查看',
    },
    auth: {
      welcome: '歡迎回來',
      welcomeNew: '加入 QQCARD',
      signinTitle: '登入 QQCARD',
      signupTitle: '建立帳號',
      email: '電子郵件',
      password: '密碼',
      confirmPassword: '確認密碼',
      forgotPw: '忘記密碼？',
      orContinue: '或使用以下方式繼續',
      noAccount: '還沒有帳號？',
      hasAccount: '已經有帳號？',
      signinBtn: '登入',
      signupBtn: '註冊',
      agree: '我已閱讀並同意服務條款與隱私權政策',
    },
    account: {
      welcome: '歡迎回來',
      vipLevel: '會員等級',
      points: 'QQCARD 點數',
      orders: '我的訂單',
      wishlist: '收藏',
      coupons: '我的優惠券',
      settings: '帳號設定',
      logout: '登出',
      nextTier: '距離下一級',
    },
    footer: {
      newsletter: '訂閱電子報',
      newsletterHint: '新遊戲與優惠資訊將寄至您的信箱，您可隨時取消。',
      subscribe: '訂閱',
      copyright: '© 2026 弘棋科技有限公司',
      legal: '客服 hshamg690111@hotmail.com · LINE @qqcard',
    },
  },
  'zh-CN': {
    brand: 'QQCARD',
    tagline: '游戏点数 · 平台储值 · 订阅服务',
    nav: {
      home: '首页',
      games: '游戏商城',
      platforms: '平台点数',
      console: '主机点卡',
      subs: '订阅服务',
      vip: 'VIP 黑卡',
      blog: '博客',
      help: '帮助中心',
      cart: '购物车',
      account: '会员中心',
      signin: '登录',
      signup: '注册',
      signout: '退出',
      search: '搜索游戏、点数、礼品卡...',
    },
    hero: {
      eyebrow: '全球顶级游戏点数平台',
      explore: '探索商城',
      vip: '加入 VIP',
      live: '在线玩家',
      todayOrders: '今日订单',
    },
    cta: {
      buyNow: '立即购买',
      addCart: '加入购物车',
      checkout: '前往结账',
      viewAll: '查看全部',
      seeMore: '看更多',
      backHome: '回到首页',
      continueShopping: '继续购物',
      payNow: '立即付款',
      apply: '应用',
      remove: '移除',
      close: '关闭',
      confirm: '确认',
      cancel: '取消',
    },
    sections: {
      categoriesEyebrow: '分类浏览',
      categoriesTitle: '一站购足你的数字生活',
      categoriesLead: '从手游、PC、主机到串流订阅，所有点卡集中管理',
      flashEyebrow: '限时闪购',
      flashTitle: 'Flash Deals · 限时优惠',
      flashLead: '每日 00:00 / 12:00 / 20:00 更新',
      hotEyebrow: '热销排行',
      hotTitle: '热卖商品',
      hotLead: 'QQCARD 平台精选热销',
      newEyebrow: '新品上架',
      newTitle: '本月新上架',
      newLead: '抢先入手最新潮流',
      featuresEyebrow: '为什么选 QQCARD',
      featuresTitle: '六大优势，重新定义游戏储值',
      vipEyebrow: '荣耀会员',
      vipTitle: 'VIP 黑卡计划',
      vipLead: '消费越多，回馈越好',
      testimonialEyebrow: '真实玩家见证',
      testimonialTitle: '50 万+ 玩家共同选择',
      blogEyebrow: '玩家攻略',
      blogTitle: '最新文章 & 教学',
      faqEyebrow: '常见问题',
      faqTitle: '想问什么，这里都有答案',
    },
    product: {
      points: '点数',
      rating: '评分',
      reviews: '条评论',
      delivery: '到账时间',
      instant: '10 秒到账',
      official: '官方授权',
      stock: '现货',
      addedToCart: '已加入购物车',
      pickAmount: '选择面额',
      qty: '数量',
      total: '小计',
      tutorial: '储值教学',
      reviewsTab: '玩家评论',
      relatedTitle: '你可能也喜欢',
    },
    cart: {
      title: '购物车',
      empty: '购物车是空的',
      emptyHint: '逛逛热销排行，挑选你心爱的点数卡',
      subtotal: '小计',
      discount: '折扣',
      vipRebate: 'VIP 回馈',
      coupon: '优惠码',
      couponPlaceholder: '输入优惠码',
      total: '应付总额',
      itemCount: '项商品',
      removeAll: '清空',
    },
    checkout: {
      title: '安全结账',
      step1: '订单明细',
      step2: '付款方式',
      step3: '完成订单',
      contact: '联系信息',
      email: '电子邮件',
      phone: '手机号码',
      payment: '选择付款方式',
      summary: '订单摘要',
      pay: '确认支付',
      processing: '安全加密处理中...',
      success: '🎉 订购成功！',
      successHint: '序号已发至您的邮箱，并可在会员中心查看',
    },
    auth: {
      welcome: '欢迎回来',
      welcomeNew: '加入 QQCARD',
      signinTitle: '登录 QQCARD',
      signupTitle: '创建帐号',
      email: '电子邮件',
      password: '密码',
      confirmPassword: '确认密码',
      forgotPw: '忘记密码？',
      orContinue: '或使用以下方式继续',
      noAccount: '还没有帐号？',
      hasAccount: '已有帐号？',
      signinBtn: '登录',
      signupBtn: '注册',
      agree: '我已阅读并同意服务条款与隐私政策',
    },
    account: {
      welcome: '欢迎回来',
      vipLevel: '会员等级',
      points: 'QQCARD 点数',
      orders: '我的订单',
      wishlist: '收藏',
      coupons: '我的优惠券',
      settings: '账号设置',
      logout: '退出',
      nextTier: '距离下一级',
    },
    footer: {
      newsletter: '订阅电子报',
      newsletterHint: '新游戏与优惠资讯将寄至您的信箱，可随时取消。',
      subscribe: '订阅',
      copyright: '© 2026 弘棋科技有限公司',
      legal: '客服 hshamg690111@hotmail.com · LINE @qqcard',
    },
  },
  en: {
    brand: 'QQCARD',
    tagline: 'Game credits · Platform top-ups · Subscriptions',
    nav: {
      home: 'Home',
      games: 'Store',
      platforms: 'Platforms',
      console: 'Console',
      subs: 'Subscriptions',
      vip: 'VIP Black',
      blog: 'Blog',
      help: 'Help',
      cart: 'Cart',
      account: 'Account',
      signin: 'Sign In',
      signup: 'Sign Up',
      signout: 'Sign Out',
      search: 'Search games, points, gift cards...',
    },
    hero: {
      eyebrow: 'The World’s Premium Game Top-up Platform',
      explore: 'Explore Store',
      vip: 'Join VIP',
      live: 'Players Online',
      todayOrders: 'Orders Today',
    },
    cta: {
      buyNow: 'Buy Now',
      addCart: 'Add to Cart',
      checkout: 'Checkout',
      viewAll: 'View All',
      seeMore: 'See More',
      backHome: 'Back Home',
      continueShopping: 'Keep Shopping',
      payNow: 'Pay Now',
      apply: 'Apply',
      remove: 'Remove',
      close: 'Close',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    sections: {
      categoriesEyebrow: 'Browse',
      categoriesTitle: 'Your one-stop digital life',
      categoriesLead: 'From mobile to PC, console to streaming — all in one place.',
      flashEyebrow: 'Flash Sale',
      flashTitle: 'Flash Deals · Limited time',
      flashLead: 'Refreshed at 00:00 / 12:00 / 20:00 every day',
      hotEyebrow: 'Best Sellers',
      hotTitle: 'Best Sellers',
      hotLead: 'QQCARD curated bestsellers',
      newEyebrow: 'New Arrivals',
      newTitle: 'Fresh This Month',
      newLead: 'Get the latest trends first',
      featuresEyebrow: 'Why QQCARD',
      featuresTitle: 'Six pillars that redefine top-up',
      vipEyebrow: 'Loyalty',
      vipTitle: 'VIP Black Program',
      vipLead: 'The more you play, the more you earn',
      testimonialEyebrow: 'Player Voices',
      testimonialTitle: 'Loved by 500K+ players',
      blogEyebrow: 'Guides',
      blogTitle: 'Latest articles & tutorials',
      faqEyebrow: 'FAQ',
      faqTitle: 'Got questions? We’ve got answers.',
    },
    product: {
      points: 'Points',
      rating: 'Rating',
      reviews: 'reviews',
      delivery: 'Delivery',
      instant: '10s delivery',
      official: 'Official',
      stock: 'In stock',
      addedToCart: 'Added to cart',
      pickAmount: 'Pick denomination',
      qty: 'Qty',
      total: 'Subtotal',
      tutorial: 'How to redeem',
      reviewsTab: 'Reviews',
      relatedTitle: 'You may also like',
    },
    cart: {
      title: 'Cart',
      empty: 'Your cart is empty',
      emptyHint: 'Browse the bestsellers to find your favorite cards',
      subtotal: 'Subtotal',
      discount: 'Discount',
      vipRebate: 'VIP Rebate',
      coupon: 'Coupon',
      couponPlaceholder: 'Enter coupon code',
      total: 'Total',
      itemCount: 'items',
      removeAll: 'Clear',
    },
    checkout: {
      title: 'Secure Checkout',
      step1: 'Order',
      step2: 'Payment',
      step3: 'Complete',
      contact: 'Contact info',
      email: 'Email',
      phone: 'Phone',
      payment: 'Payment method',
      summary: 'Order summary',
      pay: 'Pay now',
      processing: 'Processing securely...',
      success: '🎉 Order complete!',
      successHint: 'Your codes are sent to your email and saved to your account.',
    },
    auth: {
      welcome: 'Welcome back',
      welcomeNew: 'Join QQCARD',
      signinTitle: 'Sign in to QQCARD',
      signupTitle: 'Create your account',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      forgotPw: 'Forgot password?',
      orContinue: 'Or continue with',
      noAccount: 'No account?',
      hasAccount: 'Already have an account?',
      signinBtn: 'Sign in',
      signupBtn: 'Sign up',
      agree: 'I agree to the Terms of Service & Privacy Policy',
    },
    account: {
      welcome: 'Welcome',
      vipLevel: 'Tier',
      points: 'QQCARD Points',
      orders: 'Orders',
      wishlist: 'Wishlist',
      coupons: 'Coupons',
      settings: 'Settings',
      logout: 'Log out',
      nextTier: 'to next tier',
    },
    footer: {
      newsletter: 'Subscribe',
      newsletterHint: 'New game and offer updates to your inbox. Unsubscribe anytime.',
      subscribe: 'Subscribe',
      copyright: '© 2026 弘棋科技有限公司',
      legal: 'hshamg690111@hotmail.com · LINE @qqcard',
    },
  },
  ja: {
    brand: 'QQCARD',
    tagline: 'ゲームクレジット · チャージ · サブスク',
    nav: {
      home: 'ホーム',
      games: 'ストア',
      platforms: 'ポイント',
      console: 'コンソール',
      subs: 'サブスク',
      vip: 'VIPブラック',
      blog: 'ブログ',
      help: 'ヘルプ',
      cart: 'カート',
      account: 'マイページ',
      signin: 'ログイン',
      signup: '新規登録',
      signout: 'ログアウト',
      search: 'ゲーム・ポイント・ギフトカードを検索...',
    },
    hero: {
      eyebrow: '世界最高峰のゲームチャージ',
      explore: 'ストアへ',
      vip: 'VIPに参加',
      live: 'オンライン',
      todayOrders: '本日の注文',
    },
    cta: {
      buyNow: '今すぐ購入',
      addCart: 'カートに追加',
      checkout: 'お会計',
      viewAll: 'すべて見る',
      seeMore: 'もっと見る',
      backHome: 'ホーム',
      continueShopping: '買い物を続ける',
      payNow: '支払う',
      apply: '適用',
      remove: '削除',
      close: '閉じる',
      confirm: '確認',
      cancel: 'キャンセル',
    },
    sections: {
      categoriesEyebrow: 'カテゴリ',
      categoriesTitle: 'すべてここに',
      categoriesLead: 'モバイル・PC・コンソール・サブスクをワンストップで。',
      flashEyebrow: 'タイムセール',
      flashTitle: 'フラッシュディール · 期間限定',
      flashLead: '毎日 00:00 / 12:00 / 20:00 更新',
      hotEyebrow: 'ランキング',
      hotTitle: 'ベストセラー',
      hotLead: 'QQCARD 厳選人気商品',
      newEyebrow: '新着',
      newTitle: '今月の新着',
      newLead: '最新トレンドを先取り',
      featuresEyebrow: 'なぜ QQCARD',
      featuresTitle: 'チャージを再定義する6つの強み',
      vipEyebrow: 'ロイヤリティ',
      vipTitle: 'VIPブラック',
      vipLead: 'プレイするほどお得に',
      testimonialEyebrow: 'プレイヤーの声',
      testimonialTitle: '50万人以上に選ばれて',
      blogEyebrow: '攻略',
      blogTitle: '最新記事 & チュートリアル',
      faqEyebrow: 'FAQ',
      faqTitle: 'ご質問にお答えします',
    },
    product: {
      points: 'ポイント',
      rating: '評価',
      reviews: 'レビュー',
      delivery: '配信',
      instant: '10秒配信',
      official: '公式',
      stock: '在庫あり',
      addedToCart: 'カートに追加しました',
      pickAmount: '金額を選ぶ',
      qty: '数量',
      total: '小計',
      tutorial: '使い方',
      reviewsTab: 'レビュー',
      relatedTitle: 'おすすめ',
    },
    cart: {
      title: 'カート',
      empty: 'カートは空です',
      emptyHint: '人気ランキングからお気に入りを見つけよう',
      subtotal: '小計',
      discount: '割引',
      vipRebate: 'VIP還元',
      coupon: 'クーポン',
      couponPlaceholder: 'コードを入力',
      total: '合計',
      itemCount: '点',
      removeAll: 'クリア',
    },
    checkout: {
      title: '安全なお会計',
      step1: '注文',
      step2: '支払い',
      step3: '完了',
      contact: '連絡先',
      email: 'メール',
      phone: '電話番号',
      payment: '支払い方法',
      summary: '注文概要',
      pay: '支払う',
      processing: '安全に処理中...',
      success: '🎉 注文完了！',
      successHint: 'コードはメールとマイページからご確認ください。',
    },
    auth: {
      welcome: 'おかえりなさい',
      welcomeNew: 'QQCARDへようこそ',
      signinTitle: 'QQCARD にログイン',
      signupTitle: 'アカウント作成',
      email: 'メール',
      password: 'パスワード',
      confirmPassword: 'パスワード確認',
      forgotPw: 'パスワード忘れ',
      orContinue: '他の方法で続ける',
      noAccount: 'アカウントが無い？',
      hasAccount: '既にアカウント？',
      signinBtn: 'ログイン',
      signupBtn: '登録',
      agree: '利用規約とプライバシーに同意します',
    },
    account: {
      welcome: 'ようこそ',
      vipLevel: 'ランク',
      points: 'QQCARDポイント',
      orders: '注文',
      wishlist: 'お気に入り',
      coupons: 'クーポン',
      settings: '設定',
      logout: 'ログアウト',
      nextTier: '次のランクまで',
    },
    footer: {
      newsletter: 'ニュースレター登録',
      newsletterHint: '新作情報とお得情報をメールでお届けします。',
      subscribe: '登録',
      copyright: '© 2026 弘棋科技有限公司',
      legal: 'hshamg690111@hotmail.com · LINE @qqcard',
    },
  },
  ko: {
    brand: 'QQCARD',
    tagline: '게임 크레딧 · 충전 · 구독',
    nav: {
      home: '홈',
      games: '스토어',
      platforms: '플랫폼',
      console: '콘솔',
      subs: '구독',
      vip: 'VIP 블랙',
      blog: '블로그',
      help: '도움말',
      cart: '장바구니',
      account: '내 정보',
      signin: '로그인',
      signup: '회원가입',
      signout: '로그아웃',
      search: '게임, 포인트, 기프트카드 검색...',
    },
    hero: {
      eyebrow: '세계 최고의 게임 충전 플랫폼',
      explore: '스토어 둘러보기',
      vip: 'VIP 가입',
      live: '온라인',
      todayOrders: '오늘 주문',
    },
    cta: {
      buyNow: '바로 구매',
      addCart: '장바구니에 담기',
      checkout: '결제',
      viewAll: '전체 보기',
      seeMore: '더 보기',
      backHome: '홈으로',
      continueShopping: '쇼핑 계속',
      payNow: '결제하기',
      apply: '적용',
      remove: '삭제',
      close: '닫기',
      confirm: '확인',
      cancel: '취소',
    },
    sections: {
      categoriesEyebrow: '카테고리',
      categoriesTitle: '한 곳에서 다 가능',
      categoriesLead: '모바일·PC·콘솔·스트리밍 모두 QQCARD에서.',
      flashEyebrow: '특가',
      flashTitle: 'Flash Deals · 한정 특가',
      flashLead: '매일 00:00 / 12:00 / 20:00 갱신',
      hotEyebrow: '베스트',
      hotTitle: '베스트셀러',
      hotLead: 'QQCARD 큐레이션 인기 상품',
      newEyebrow: '신상품',
      newTitle: '이달의 신상',
      newLead: '최신 트렌드를 가장 먼저',
      featuresEyebrow: '왜 QQCARD',
      featuresTitle: '충전을 재정의하는 6가지',
      vipEyebrow: '멤버십',
      vipTitle: 'VIP 블랙',
      vipLead: '쓸수록 더 많이 적립',
      testimonialEyebrow: '리뷰',
      testimonialTitle: '50만+ 플레이어의 선택',
      blogEyebrow: '가이드',
      blogTitle: '최신 글 & 튜토리얼',
      faqEyebrow: 'FAQ',
      faqTitle: '궁금한 점은 여기서',
    },
    product: {
      points: '포인트',
      rating: '평점',
      reviews: '리뷰',
      delivery: '배송',
      instant: '10초 배송',
      official: '공식',
      stock: '재고',
      addedToCart: '장바구니에 담음',
      pickAmount: '금액 선택',
      qty: '수량',
      total: '소계',
      tutorial: '사용법',
      reviewsTab: '리뷰',
      relatedTitle: '추천',
    },
    cart: {
      title: '장바구니',
      empty: '장바구니가 비어 있어요',
      emptyHint: '인기 상품에서 마음에 드는 카드를 골라보세요',
      subtotal: '소계',
      discount: '할인',
      vipRebate: 'VIP 적립',
      coupon: '쿠폰',
      couponPlaceholder: '코드 입력',
      total: '합계',
      itemCount: '개',
      removeAll: '비우기',
    },
    checkout: {
      title: '안전 결제',
      step1: '주문',
      step2: '결제',
      step3: '완료',
      contact: '연락처',
      email: '이메일',
      phone: '전화',
      payment: '결제 수단',
      summary: '주문 요약',
      pay: '결제',
      processing: '안전하게 처리 중...',
      success: '🎉 주문 완료!',
      successHint: '코드는 이메일과 마이페이지에서 확인할 수 있어요.',
    },
    auth: {
      welcome: '환영합니다',
      welcomeNew: 'QQCARD 시작하기',
      signinTitle: 'QQCARD 로그인',
      signupTitle: '계정 만들기',
      email: '이메일',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
      forgotPw: '비밀번호를 잊으셨나요?',
      orContinue: '다른 방법으로 계속',
      noAccount: '계정이 없으신가요?',
      hasAccount: '이미 계정이 있나요?',
      signinBtn: '로그인',
      signupBtn: '가입',
      agree: '약관 및 개인정보 정책에 동의합니다',
    },
    account: {
      welcome: '환영합니다',
      vipLevel: '등급',
      points: 'QQCARD 포인트',
      orders: '주문',
      wishlist: '찜',
      coupons: '쿠폰',
      settings: '설정',
      logout: '로그아웃',
      nextTier: '다음 등급까지',
    },
    footer: {
      newsletter: '뉴스레터 구독',
      newsletterHint: '신작 게임과 혜택 정보를 이메일로 받아보세요.',
      subscribe: '구독',
      copyright: '© 2026 弘棋科技有限公司',
      legal: 'hshamg690111@hotmail.com · LINE @qqcard',
    },
  },
};

export const useT = (lang) => T[lang] || T['zh-TW'];
